export default __webpack_public_path__ + "static/media/Original.56d33305.jpg";